import { ApiUtility } from "../Utilities/ApiUtility.axios";

class PracticeBankAccountsService {
  route = "/Practice/BankAccounts";
  get = (recordId: string) => ApiUtility.getResult(`${this.route}/${recordId}`);

  getList = (
    start: number,
    length: number,
    search?: string,
    status?: any,
    practiceId: number = 0
  ) =>
    ApiUtility.getResult(`${this.route}`, {
      start,
      length,
      search,
      status,
      practiceId,
    });
  create = (id: string, params: any) =>
    ApiUtility.post(`${this.route}${id ? "/" + id : ""}`, params);

  remove = (id: string, practiceId: number) =>
    ApiUtility.post(`${this.route}/${id}/Delete?practiceId=${practiceId}`, {});

  markPrimary = (id: string, practiceId: number) =>
    ApiUtility.post(`${this.route}/${id}/Primary?practiceId=${practiceId}`, {});
}

export default new PracticeBankAccountsService();
